export const getVolByID = (state, id) => state.getIn(['byId', id]);

export const getVolsByScanID = (state, scanID) =>
  state
    .get('byId')
    .filter(vol => vol.get('scanID') === scanID)
    .toList();

export const getSeriesAlphaByID = (state, volID) => state.getIn(['byId', volID, 'seriesAlpha']);
